import { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { loginCall } from "../../../api/api";
import history from "../../../helpers/history";
import { getInitialRoute, onEnter } from "../../../helpers/helpers";

function Basic() {
  const onSignIn = async () => {
    if (!state.userName) {
      return global.showAlert("Validation Errors", "User Name is required to login", "warning");
    }
    if (!state.password) {
      return global.showAlert("Validation Errors", "Password is required to login", "warning");
    }
    const response = await loginCall(state.userName, state.password);
    if (response) {
      history.navigate(getInitialRoute(), {
        replace: true,
      });
    } else {
      return global.showAlert(
        "Unable to Login",
        "Please check your user name and password",
        "warning"
      );
    }
  };

  const [state, setState] = useState({
    userName: "",
    password: "",
  });
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox justifySelf="center" mb={4} textAlign={"center"}>
            <img src="/images/logo.png" height={90} style={{ borderRadius: 10 }} />
          </MDBox>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="string"
                label="User Name"
                fullWidth
                value={state.userName}
                onChange={(event) => {
                  setState({ ...state, userName: event.target.value.toLowerCase() });
                }}
                autoComplete="off"
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                label="Password"
                fullWidth
                value={state.password}
                onChange={(event) => {
                  setState({ ...state, password: event.target.value });
                }}
                onKeyDown={(e) => {
                  onEnter(e, onSignIn);
                }}
                autoComplete="off"
                inputProps={{
                  style: { WebkitTextSecurity: "disc" },
                }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton onClick={onSignIn} variant="gradient" color="info" fullWidth>
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
